import { Subscription, Observable } from 'rxjs';

export class AlertBanner {
	type: string;
	autoAction = false;
	timer: Subscription;
	secondsLeft: number;
	action: () => void;
}